export default __webpack_public_path__ + "static/media/GRUPO_3_2026.2faaadab.pdf";